/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import i18next from "i18next";
import PropTypes from "prop-types";
import { DivBackgroundOpacity } from "@utils/extra-style";

const GeneralInfo = (props) => {
  const { t, data, column } = props;
  return (
    <>
      <DivBackgroundOpacity opacity={data.status ? "1" : "0.2"}>
        {column === "id" && <div>{data.id}</div>}
        {column === "name" && <div>{data.name}</div>}
        {column === "volume" && (
          <div>
            {t(data.volume)} {t("M3")}
          </div>
        )}
        {column === "averageWeight" && (
          <div>
            {data.averageWeight} {t("TONS")}
          </div>
        )}
        {column === "minWeight" && (
          <div>
            {data.minWeight} {t("TONS")}
          </div>
        )}
        {column === "maxWeight" && (
          <div>
            {data.maxWeight} {t("TONS")}
          </div>
        )}
      </DivBackgroundOpacity>
    </>
  );
};

GeneralInfo.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};

GeneralInfo.defaultProps = {
  page: null,
};

export default withTranslation()(GeneralInfo);
